<template>
  <div class="border-t pt-6 space-y-4">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <div>
        <label class="block text-sm font-semibold text-gray-700 mb-2">Firmenkürzel *</label>
        <input :value="firmenkuerzel" @input="$emit('update:firmenkuerzel', $event.target.value)"
          class="w-full border-2 border-gray-300 rounded-xl px-4 py-3 focus:border-caspyellow focus:ring-2 focus:ring-caspyellow focus:ring-opacity-20 focus:outline-none transition-all duration-200"
          placeholder="z.B. PSSEC" />
      </div>
      <div>
        <label class="block text-sm font-semibold text-gray-700 mb-2">Personalnummern-Präfix</label>
        <input :value="persnrPrefix" @input="$emit('update:persnrPrefix', $event.target.value)"
          class="w-full border-2 border-gray-300 rounded-xl px-4 py-3 focus:border-caspyellow focus:ring-2 focus:ring-caspyellow focus:ring-opacity-20 focus:outline-none transition-all duration-200"
          placeholder="z.B. SUB20" />
        <p class="mt-1 text-xs text-gray-500">Bereich für Mitarbeiter-Personalnummern dieser Fremdfirma (Format: SUB&lt;Ziffern&gt;).</p>
      </div>
      <div>
        <label class="block text-sm font-semibold text-gray-700 mb-2">Bew-Id-Nr.</label>
        <input :value="bewIdNr" @input="$emit('update:bewIdNr', $event.target.value)"
          class="w-full border-2 border-gray-300 rounded-xl px-4 py-3 focus:border-caspyellow focus:ring-2 focus:ring-caspyellow focus:ring-opacity-20 focus:outline-none transition-all duration-200"
          placeholder="z.B. BWR-123456" />
        <p class="mt-1 text-xs text-gray-500">Wird in der Meldeliste beim Arbeitgeber in Klammern angehängt.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubunternehmerFields",
  props: {
    firmenkuerzel: {
      type: String,
      default: "",
    },
    persnrPrefix: {
      type: String,
      default: "",
    },
    bewIdNr: {
      type: String,
      default: "",
    },
  },
  emits: ["update:firmenkuerzel", "update:persnrPrefix", "update:bewIdNr"],
};
</script>
